angular.module('bribac.services.errorUtils', [])

.factory('errorUtils', function() {
  return {
    parseErrorResponse: function (request) {
      return (request.data && request.data.errorMessage)
        ? request.data.errorMessage
        : request.data.errors && request.data.errors[0] ? request.data.errors[0].message
          : (request.statusText || 'Unknown error')
    }
  }
});
